import { ReviewsBlock } from "../../../types";
import GoogleTestimonials from "@/components/Landingpage/GoogleRating";

interface ReviewsProps {
  block: ReviewsBlock;
}

export default function Reviews({ block }: ReviewsProps) {
  // If explicitly hidden in block config (future proofing), return null.
  // But schema defaults to true.
  // We can ignore block.reviews since we fetch dynamically in the component.

  return (
    <div className="reviews-block-wrapper">
      <GoogleTestimonials title={block.title} />
    </div>
  );
}
